import script from "./AddProductsToCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProductsToCampaign.vue?vue&type=script&setup=true&lang=js"

import "./AddProductsToCampaign.vue?vue&type=style&index=0&id=0ddcc09c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ddcc09c"]])

export default __exports__